import React from 'react'

const PublishedSpecialIssues = () => {
  return (
    <div>
        <p>Below is a list of previously published Special Issues:  </p>
        <ol>
            <li>
                <h4 className="fw-bold text-blue font-size-21">[Title of Published Special Issue]</h4>
                <ul>
                    <li><b>Guest Editors:</b> [Name, Affiliation] </li>
                    <li><b>Scope:</b> [Brief description of the theme]</li>
                    <li><b>Submission Deadline:</b> [Date] </li>
                    <li><b>Publication Date:</b> [Expected publication timeline] </li>
                </ul>
            </li>
        </ol>
        <p>
        The <b>International Journal of Interdisciplinary Studies and Syste m Science </b> is committed to fostering <b>high-impact legal research</b> through Special Issues that contribute to legal scholarship and practice. 
        </p>
    </div>
  )
}

export default PublishedSpecialIssues